<template>
	<el-dialog
		:title="title"
		:visible.sync="visible"
    class="custom-el-wrapper"
		width="400px"
		@close="handlerCancel"
	>
		<el-select v-model="current_id" placeholder="请选择PDD账号" class="w-full">
			<el-option v-for="item in list" :label="item.phone + '    '+( item.name ?? '' )" :value="item.id" :key="item.id"></el-option>
		</el-select>
		<el-input
			class="mt-2"
			v-model="order_no"
			placeholder="请输入订单号"
			:type="type"
			:rows="2"
		/>

		<span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
	</el-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
	data() {
		return {
			current_id: null,
			visible: false,
			value: {},
			order_no: '',
			account: '',
			list: [],
			callback: null,
			title: '',
			func: null,
			assemble: null,
			type: 'text',
		}
	},
	mounted() {
		this.opPddAccountList({
			data: {
				page: 1,
				limit: 99999,
				type: 1,
                group_ids: [],
			},
			success: (res) => {
				this.list = res.data.data;
				if (this.list.length > 0) {
					for (let i = 0; i < this.list.length; i++) {
						if (this.list[i].phone == this.account) {
							this.current_id = this.list[i].id;
						}
					}
				}
			}
		})
	},
	methods: {
		...mapActions({
			opPddAccountList: "ucenter_order/opPddAccountList",
		}),
		open(title, value, func, assemble, callback, type = 'text') {
			this.title = title;
			this.value = value;
			this.order_no = value.order_no;
			this.account = value.account;
			this.func = func;
			this.assemble = assemble;
			this.callback = callback;
			this.type = type
			this.visible = true;
			if (this.list.length > 0) {
				this.current_id = null;
				for (let i = 0; i < this.list.length; i++) {
					if (this.list[i].phone == this.account) {
						this.current_id = this.list[i].id;
					}
				}
			}
		},
		handlerConfirm() {
			this.func({
				data: this.assemble({pdd_order_no:this.order_no, pdd_account_id: this.current_id}),
				success: (res) => {
					this.callback(res);
					this.visible = false;
				},
			})
		},
		handlerCancel() {
			this.visible = false;
		},
	}
}
</script>

<style scoped>

</style>
